import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoadingComponent, { LoadingWrapper } from 'components/LoadingComponent/LoadingComponent';
import { updateZendeskTicketField } from 'api/tickets/zendesk';
import { addEdgeToDecisionTreePath } from 'actions/searchActions';
import { addNoteToSelectedTicket } from 'actions';
import { handleError } from 'services/ErrorService/ErrorService';
import { getSelectedRbiStore } from 'selectors/tools';
import {
  isSelectedTicketTaken,
  getSimplrAccountIdOfSelectedTicket,
  extractSelectedTicketFromState,
  isSpecialist,
} from 'extractFromState';
import { getStoreAddress } from './DTRBIUpdateFieldWithStoreIdNodeHelpers';

const DTRBIUpdateFieldWithStoreIdNode = () => {
  const dispatch = useDispatch();

  const selectedStore = useSelector(getSelectedRbiStore);
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const selectedTicketTaken = useSelector(isSelectedTicketTaken);
  const { platformTicketId } = useSelector(extractSelectedTicketFromState);
  const isAdmin = useSelector(isSpecialist);

  useEffect(() => {
    (async () => {
      try {
        if (!selectedStore) {
          return handleError({
            error: {},
            customMessage: 'Please select a store.',
            showPopup: true,
          });
        }
        if (!selectedTicketTaken && !isAdmin) {
          return handleError({
            error: {},
            customMessage: 'You must take this ticket to proceed.',
            showPopup: true,
          });
        }

        if (isAdmin && !selectedTicketTaken) {
          return dispatch(addEdgeToDecisionTreePath('store_id_updated'));
        }

        const storeAddress = getStoreAddress(selectedStore);

        await Promise.all([
          updateZendeskTicketField({
            fieldName: 'Store ID',
            value: String(selectedStore.storeNumber),
            simplrAccountId,
            ticketId: platformTicketId,
          }),
          updateZendeskTicketField({
            fieldName: 'Store Address ',
            value: storeAddress,
            simplrAccountId,
            ticketId: platformTicketId,
          }),
        ]);

        await dispatch(
          addNoteToSelectedTicket(
            `Updated the Store ID field in the partner's ticketing system to ${selectedStore.storeNumber} and the store address field to ${storeAddress}`
          )
        );

        dispatch(addEdgeToDecisionTreePath('store_id_updated'));
      } catch (error) {
        handleError({
          error,
          customMessage: 'There was a problem tagging the ticket with the selected store ID and address.',
          showPopup: true,
        });
      }
    })();
  }, [selectedStore, platformTicketId, selectedTicketTaken, simplrAccountId, isAdmin, dispatch]);

  return (
    <LoadingWrapper>
      <LoadingComponent delay={0} />
    </LoadingWrapper>
  );
};

export default DTRBIUpdateFieldWithStoreIdNode;
